import { BModal } from 'bootstrap-vue'
import util from '@/util'
import mensagens from '@/util/mensagens'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'

export default {
  name: 'contratar-produto',
  components: {
    'b-modal': BModal,
    spinnerProcessando
  },
  props: {
    plano: {
      type: Object
    },
    efetuarContratacao: {
      type: [Function]
    }
  },
  computed: {
    obterTituloModal () {
      const nomeProduto = this.plano.produto.nome ?? ''
      const nomePlano = this.plano.nome ?? ''
      return `Contratar Plano ${nomePlano} do Produto ${nomeProduto}`
    }
  },
  data: () => {
    return {
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      formulario: {
        senha_usuario: null,
        aceite_contrato: false,
        quantidade: 0
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: [],
        listaDados: {}
      }
    }
  },
  methods: {
    async aceitarContrato (bvModalEvt) {
      bvModalEvt.preventDefault()
      const validacaoOk = this.validarDadosFormulario()
      if (validacaoOk) {
        await this.efetuarAceiteContrato()
      }

      this.tratarAposSalvarRegistro()
    },
    async efetuarAceiteContrato () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.efetuarContratacao(this.formulario)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        this.retorno.listaDados = resposta.data.retorno.listaDados
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    tratarAposSalvarRegistro () {
      if (this.retorno.sucesso) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', this.retorno.mensagem)
        this.$bvModal.hide('modalContratarProduto')
        const dadosRetornoContrato = this.retorno.listaDados
        this.$emit('contratoConfirmado', dadosRetornoContrato)
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
      }
    },
    validarDadosFormulario () {
      this.resetarListaDeErros()
      const formulario = util.mapearObjetos(this.formulario, {})
      if (util.valorVazio(formulario.senha_usuario)) {
        this.retorno.listaDeErros['senha_usuario'] = 'Este campo é obrigatório'
      }
      if (formulario.aceite_contrato === false) {
        this.retorno.listaDeErros['aceite_contrato'] = 'Este campo é obrigatório'
      }
      if (formulario.quantidade <= 0) {
        this.retorno.listaDeErros['quantidade'] = 'Este campo deve ser maior que 0'
      }
      if (util.valorVazio(formulario.quantidade)) {
        this.retorno.listaDeErros['quantidade'] = 'Este campo é obrigatório'
      }
      const validacaoOk = Object.values(this.retorno.listaDeErros).length === 0
      return validacaoOk
    },
    resetarDados () {
      this.formulario = {
        senha_usuario: null,
        aceite_contrato: false,
        quantidade: 0
      }
      this.resetarListaDeErros()
    },
    tratarEventoFecharModal (bvModalEvt) {
      if (this.flagsDeControle.carregandoDados.status) {
        bvModalEvt.preventDefault()
      }
    },
    resetarListaDeErros () {
      this.retorno.sucesso = false
      this.retorno.mensagem = ''
      this.retorno.listaDeErros = []
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    mascaraQuantidade () {
      this.formulario.quantidade = util.apenasNumeros(this.formulario.quantidade) ?? 1
    }
  }
}
